import { render, staticRenderFns } from "./traMediciCount.vue?vue&type=template&id=b913afe2&scoped=true"
import script from "./traMediciCount.vue?vue&type=script&lang=js"
export * from "./traMediciCount.vue?vue&type=script&lang=js"
import style0 from "./traMediciCount.vue?vue&type=style&index=0&id=b913afe2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b913afe2",
  null
  
)

export default component.exports